// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"c64e096b","887":"674f949c"}[chunkId] + ".chunk.js";
};